import { View, Text } from "@react-pdf/renderer";
import { centsToDollars, parsePrice } from "helpers/price";
import { useMemo } from "react";
import { IAbnNotice } from "types/AbnNotice/AbnNotice";

import { styles } from "../styles";

export function ProceduresSection({
  activeAbnNotice,
}: {
  activeAbnNotice?: IAbnNotice | null;
}) {
  const procedures = useMemo(() => {
    return activeAbnNotice?.documentSnapshot?.procedures;
  }, [activeAbnNotice]);
  const procedureCodes = useMemo(() => {
    return procedures?.map((procedure: any) => procedure.cptCode);
  }, [procedures]);
  return (
    <View
      style={{
        marginTop: 5,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Text
        style={{
          ...styles.bodyText,
          fontFamily: "Helvetica-Bold",
          fontSize: 12,
          marginBottom: 3,
        }}
      >
        <Text style={{ fontStyle: "underline" }}>NOTE: </Text>
        If Medicare doesn&apos;t pay for D.{" "}
        <Text style={{ textDecoration: "underline" }}>
          {procedureCodes?.join(", ")}
        </Text>{" "}
        below, you may have to pay.
      </Text>
      <Text
        style={{
          ...styles.bodyText,
          fontSize: 12,
          marginBottom: 5,
        }}
      >
        Medicare does not pay for everything, even some care that you or your
        health care provider have good reason to think you need. We expect
        Medicare may not pay for the D.{" "}
        <Text style={{ textDecoration: "underline" }}>
          {procedureCodes?.join(", ")}
        </Text>{" "}
        below.
      </Text>
      <View
        style={{
          borderWidth: 1,
          borderColor: "#000",
          marginTop: 5,
          flexDirection: "row",
        }}
      >
        {/* Column D */}
        <View
          style={{
            width: "35%",
            borderRightWidth: 1,
            borderColor: "#000",
            padding: 0,
          }}
        >
          <View
            style={{
              backgroundColor: "#f0f0f0",
              padding: 4,
              borderBottomWidth: 1,
              borderColor: "#000",
            }}
          >
            <Text
              style={{
                ...styles.bodyText,
                fontFamily: "Helvetica-Bold",
                fontSize: 11,
                marginBottom: 2,
              }}
            >
              D.
            </Text>
          </View>

          <View
            style={{
              padding: 4,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {procedures.map((procedure: any, index: number) => (
              <Text
                key={`${procedure.cptCode}-${index}`}
                style={{
                  ...styles.bodyText,
                  fontSize: 10,
                  marginBottom: 2,
                }}
              >
                {procedure.cptCode} – {procedure.cptDescription}
              </Text>
            ))}
          </View>
        </View>

        {/* Column E – single reason text for all */}
        <View
          style={{
            width: "40%",
            borderRightWidth: 1,
            borderColor: "#000",
            padding: 0,
          }}
        >
          <View
            style={{
              backgroundColor: "#f0f0f0",
              padding: 4,
              borderBottomWidth: 1,
              borderColor: "#000",
            }}
          >
            <Text
              style={{
                ...styles.bodyText,
                fontFamily: "Helvetica-Bold",
                fontSize: 11,
                marginBottom: 2,
              }}
            >
              E. Reason Medicare May Not Pay
            </Text>
          </View>
          <View
            style={{
              padding: 4,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Text
              style={{
                ...styles.bodyText,
                fontSize: 10,
              }}
            >
              {activeAbnNotice?.documentSnapshot?.reason ||
                `Medicare does not consider the procedure(s) listed above medically
              necessary for your condition or deems them experimental.`}
            </Text>
          </View>
        </View>

        {/* Column F */}
        <View
          style={{
            width: "25%",
            padding: 0,
          }}
        >
          <View
            style={{
              backgroundColor: "#f0f0f0",
              padding: 4,
              borderBottomWidth: 1,
              borderColor: "#000",
            }}
          >
            <Text
              style={{
                ...styles.bodyText,
                fontFamily: "Helvetica-Bold",
                fontSize: 11,
                textAlign: "right",
                marginBottom: 2,
                padding: 0,
              }}
            >
              F. Estimated Cost
            </Text>
          </View>
          <View
            style={{
              padding: 4,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {procedures.map((procedure: any, index: number) => (
              <Text
                key={`${procedure.cptCode}-amount-${index}`}
                style={{
                  ...styles.bodyText,
                  fontSize: 10,
                  textAlign: "right",
                  marginBottom: 2,
                }}
              >
                {parsePrice(centsToDollars(procedure.amount))}
              </Text>
            ))}
          </View>
        </View>
      </View>
    </View>
  );
}
